<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" [disabled]="disabled()" class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy">
  <thead>
    <tr>
      <th scope="col" style="min-width: 110px">Data Histórico</th>
      <th scope="col" style="min-width: 110px">Processo</th>
      <th scope="col" style="min-width: 110px">Data Início</th>
      <th scope="col" style="min-width: 110px">Data Término</th>
      <th scope="col" style="width: 30%">Tipo Contratação</th>
      <th scope="col" style="min-width: 120px">Valor Caução</th>
      <th scope="col" style="min-width: 120px">Valor Contrato</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td>{{item.data_historico | date: 'dd/MM/yyyy':'GMT'}}</td>
      <td>{{item.processo}}</td>
      <td>{{item.data_inicio | date: 'dd/MM/yyyy':'GMT'}}</td>
      <td>{{item.data_termino | date: 'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="item.tipo_contratacao">{{item.tipo_contratacao.nome}}</td>
      <td *ngIf="!item.tipo_contratacao">-</td>
      <td>{{item.valor_caucao | number: '1.2-2'}}</td>
      <td>{{item.valor_contrato | number: '1.2-2'}}</td>
      <td class="text-right" style="min-width: 110px;">
        <button *ngIf="!item.editavel && item.id && funcaoService.podeAlterar(item.data_historico, login)" (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel && funcaoService.podeAlterar(item.data_historico, login)" (click)="remover(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>
<app-contrato-historico-dlg [(lista)]="lista" [(entidade)]="itemAtual" [login]="login" [(listaContratacao)]="listaContratacao">
</app-contrato-historico-dlg>